import * as React from "react";
const SvgOkta = props => <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" {...props}><circle cx={12} cy={12} r={9} style={{
    fill: "none",
    stroke: "#007dc1",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }} /></svg>;
export { SvgOkta as ReactComponent };
export default __webpack_public_path__ + "static/media/okta.49eee749b4.svg";